import client from './client';

export const createOrg    = (data)         => client.post('/api/orgs', data);
export const getOrgBySlug = (slug)         => client.get(`/api/orgs/${slug}`);
export const listMyOrgs   = (memberEmail)  => client.get('/api/orgs', { params: { memberEmail } });

/** SUPER_ADMIN: list all organizations (GET /api/orgs with no filter). */
export const listAllOrganizations = () => client.get('/api/orgs');
export const inviteMember = (orgId, data)  => client.post(`/api/orgs/${orgId}/members`, data);
export const listMembers  = (orgId)        => client.get(`/api/orgs/${orgId}/members`);
export const removeMember = (orgId, email) => client.delete(`/api/orgs/${orgId}/members/${encodeURIComponent(email)}`);

// Phase 10: Settings page extras
export const getOrgById = (orgId)          => client.get(`/api/orgs/id/${orgId}`);
export const updateOrg  = (orgId, data)    => client.put(`/api/orgs/${orgId}`, data);
export const deleteOrg  = (orgId, slugConfirmation) =>
    client.delete(`/api/orgs/${orgId}`, { data: { slugConfirmation } });
